import Api from '../services/api.js'
import * as types from '../constants'

export function getUsersRequest(){
  return {
    type: types.GET_USERS_REQUEST
  }
}

export function getUsersSuccess(body){
  return {
    type: types.GET_USERS_SUCCESS,
    body: body
  }
}

export function getUsersFailure(exception){
  return {
    type: types.GET_USERS_FAILURE,
    exception: exception
  }
}

export function createUserRequest(){
  return {
    type: types.CREATE_USER_REQUEST
  }
}

export function createUserSuccess(body){
  return {
    type: types.CREATE_USER_SUCCESS,
    body: body
  }
}

export function createUserFailure(exception){
  return {
    type: types.CREATE_USER_FAILURE,
    exception: exception
  }
}

export function updateUserRequest(){
  return {
    type: types.UPDATE_USER_REQUEST
  }
}

export function updateUserSuccess(body){
  return {
    type: types.UPDATE_USER_SUCCESS,
    body: body
  }
}

export function updateUserFailure(exception){
  return {
    type: types.UPDATE_USER_FAILURE,
    exception: exception
  }
}

export function deleteUserRequest(){
  return {
    type: types.DELETE_USER_REQUEST
  }
}

export function deleteUserSuccess(body){
  return {
    type: types.DELETE_USER_SUCCESS,
    body: body
  }
}

export function deleteUserFailure(exception){
  return {
    type: types.DELETE_USER_FAILURE,
    exception: exception
  }
}

export function getUserTagsRequest(){
  return {
    type: types.GET_USER_TAGS_REQUEST
  }
}

export function getUserTagsSuccess(body){
  return {
    type: types.GET_USER_TAGS_SUCCESS,
    body: body
  }
}

export function getUserTagsFailure(){
  return {
    type: types.GET_USER_TAGS_FAILURE
  }
}

const getUsersApi = new Api()
export function getUsers(options) {
  getUsersApi.cancelPendingRequest();

  let params = {
    params: options,
    cancelToken: getUsersApi.giveCancelToken()
  }

  return dispatch => {
    dispatch(getUsersRequest());
    return getUsersApi.get("/__api/v1/users", params)
    .then(response => {
      dispatch(getUsersSuccess(response.data))
    })
    .catch(err => dispatch(getUsersFailure(err)));
  }
}

export function createUser(user) {
  let params = {
    user: user
  }
  return dispatch => {
    dispatch(createUserRequest());
    const api = new Api();
    return api.post("/__api/v1/user", params)
    .then(response => {
      dispatch(createUserSuccess(response.data))
    })
    .catch(err => dispatch(createUserFailure(err)));
  }
}

export function updateUser(user) {
  let params = {
    user: user
  }
  return dispatch => {
    dispatch(updateUserRequest());
    const api = new Api();
    return api.put("/__api/v1/user/"+user.id, params)
    .then(response => {
      dispatch(updateUserSuccess(response.data))
    })
    .catch(err => dispatch(updateUserFailure(err)));
  }
}

export function deleteUser(user) {
  let params = {
    user: user
  }
  return dispatch => {
    dispatch(deleteUserRequest());
    const api = new Api();
    return api.delete("/__api/v1/user/"+user.id, params)
    .then(response => {
      dispatch(deleteUserSuccess(response.data))
    })
    .catch(err => dispatch(deleteUserFailure(err)));
  }
}

export function getUserTags(options) {
  let params = { params: options }

  return dispatch => {
    dispatch(getUserTagsRequest());
    const api = new Api();
    return api.get("/__api/v1/user_tags", params)
    .then(response => {
      dispatch(getUserTagsSuccess(response.data))
    })
    .catch(err => dispatch(getUserTagsFailure(err)));
  }
}

export function clearUserError() {
  return dispatch => {
    dispatch({
      type: types.CLEAR_USER_ERROR
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/user.js